import React from 'react';
import { Modal, ModalTitle, ModalBody, ModalFooter } from '@vds/modals';
import PropTypes from 'prop-types';
import Button from '../Button';

const CommonModal = (props) => (
  <Modal
    id={props.id}
    ariaLabel={props.ariaLabel}
    closeButton={props.closeButton}
    customScroll={props.customScroll}
    disableOutsideClick={props.disableOutsideClick}
    showCloseButton={props.showCloseButton}
    hideCloseButton={props.hideCloseButton}
    opened={props.opened}
    onOpenedChange={props.onOpenedChange}
    showModal={props.showModal}
    className={props.className}
    fullScreenDialog={props.fullScreenDialog}
    disableAnimation={props.disableAnimation}
    toggleButton={props.toggleButton ? <Button> {props.toggleButton} </Button> : ''}
    closeButtonId={props.closeButtonId}
    contentContainer={props.contentContainer}
    data-track={props?.dataTrack || `${props?.ariaLabel}`}
  >
    {props.modalTitle && <ModalTitle>{props.modalTitle}</ModalTitle>}
    <ModalBody>{props.modalBody}</ModalBody>
    {props.modalFooter && <ModalFooter>{props.modalFooter}</ModalFooter>}
  </Modal>
);
CommonModal.defaultProps = {
  fullScreenDialog: false,
  disableAnimation: false,
};
CommonModal.propTypes = {
  id: PropTypes.string,
  ariaLabel: PropTypes.string,
  closeButton: PropTypes.func,
  customScroll: PropTypes.func,
  disableOutsideClick: PropTypes.func,
  showCloseButton: PropTypes.bool,
  hideCloseButton: PropTypes.bool,
  opened: PropTypes.bool,
  onOpenedChange: PropTypes.func,
  showModal: PropTypes.func,
  modalTitle: PropTypes.string,
  modalBody: PropTypes.string,
  className: PropTypes.string,
  modalFooter: PropTypes.string,
  fullScreenDialog: PropTypes.bool,
  disableAnimation: PropTypes.bool,
  toggleButton: PropTypes.string,
  contentContainer: PropTypes.string,
  closeButtonId: PropTypes.any,
  dataTrack: PropTypes.string,
};

export default CommonModal;
